export enum JsonResponseStatus {
  success = "success",
  failed = "failed,",
}
